import type { ApiResponse } from '@/api/base';
import type { CommonStoreSetState } from '@/store/helpers';

export const fetchToStore = async (
  fetchFunction: () => Promise<ApiResponse<unknown>>,
  storeKey: string,
  setState: CommonStoreSetState,
  pendingKey?: string
) => {
  pendingKey && setState({ [pendingKey]: true });
  return fetchFunction()
    .then(({ data }) => {
      if (!data) return;
      setState({ [storeKey]: data });
    })
    .finally(() => {
      pendingKey && setState({ [pendingKey]: false });
    });
};
